export const ROUTE_PATH_TOURNAMENTS = "/tournaments";
